<template>
  <div class="alert alert-info">
    <div v-for="notice in notices" :key="notice.id">
        <span v-html="notice.content" class="notice"></span>
    </div>
  </div>
</template>
<script>


export default {
  props: {
    notices: {
      default: [],
    },
  },
}

</script>

<style scoped lang="scss">
  .notice :deep(p) {
    margin:0!important;
    color: $swift-not-black;
    a {
      color:#3a87ad;
    }
  }
</style>